import Vue from "vue";
import Router from "vue-router";
import routes from "./router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from) => {
  window.scrollTo(0, 0);
});

router.beforeEach(async (to, from, next) => {
  // const host = window.location.hostname;

  // if (to.path === "/" || to.path === "/home") {
  //   if (host.indexOf("rxjh01.zqtjgame.com") > -1) {
  //     return next("/baidu01");
  //   }
  //   if (host.indexOf("rxjh02.zqhutj.com") > -1) {
  //     return next("/baidu02");
  //   }
  // }

  if (to.meta && to.meta.auth && to.meta.auth.length > 0) {
    for (let auth of to.meta.auth) {
      // 登录权限校验
    }
  }
  next();
});

export default router;
